import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Box, Toolbar } from '@mui/material';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [sidebarOpen]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      
    
      <Sidebar 
        open={sidebarOpen} 
        toggleSidebar={() => setSidebarOpen(prev => !prev)} 
        sx={{
          width: sidebarOpen ? '220px' : '70px', 
          overflowX: "visible",
        }} 
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          transition: 'all 0.3s ease',
          overflowY: 'auto', 
          height: '100vh',
        }}
      >
        <Toolbar />
        <Outlet context={{ sidebarOpen }} />
      </Box>
    </Box>
  );
};

export default Layout;
